import _pick from 'lodash/pick';
import { getGlobalProps } from '../utils/queryHelpers';

const FIELDS = ['description', 'expired', 'id', 'name', 'orgId', 'rowVersion'];

const LcpReason = () => {
  const {
    orgInfo: { orgId }
  } = getGlobalProps();

  return {
    id: null,
    name: null,
    description: null,
    expired: false,
    orgId
  };
};

export const sanitize = values => {
  const { id, rowVersion, orgId, expired, ...initialValues } = _pick(
    values,
    FIELDS
  );
  if (id) {
    return {
      ...initialValues,
      id,
      rowVersion,
      expired: !expired
    };
  }
  return {
    ...initialValues,
    orgId
  };
};

export default LcpReason;
